import React, { useEffect, useState } from 'react';
import { FormControl, Select, MenuItem, Checkbox, ListItemText } from '@mui/material';

const StatusFilter = ({ onStatusChange }) => {
    const [status, setStatus] = useState([])

    const statusOptions = [
        { value: 'OPN', label: 'Open' },
        { value: 'PRG', label: 'In Progress' }
    ];

    const handleSelectAll = () => {
        onStatusChange(['OPN', 'PRG']);
        setStatus(['OPN', 'PRG'])
    };

    const handleDeselectAll = () => {
        onStatusChange([]);
        setStatus([])
    };

    const handleStatusChange = (event) => {
        const value = event.target.value;
        if (value.includes('selectAll')) {
            handleSelectAll();
        } else if (value.includes('deselectAll')) {
            handleDeselectAll();
        } else {
            onStatusChange(value);
            setStatus(value);
        }
    };

    return (
        <FormControl size="small" sx={{ minWidth: 150 }}>
            <Select
                multiple
                value={status}
                onChange={handleStatusChange}
                displayEmpty
                renderValue={(selected) => 
                    selected.length === 0 ? 'Filter by Status' : 
                    selected.length === statusOptions.length ? 'All Statuses' :
                    `${selected.length} selected`
                }
            >
                <MenuItem value="selectAll">
                    <em>Select All</em>
                </MenuItem>
                <MenuItem value="deselectAll">
                    <em>Deselect All</em>
                </MenuItem>
                {statusOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        <Checkbox checked={status.includes(option.value)} />
                        <ListItemText primary={option.label} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default StatusFilter;